
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import AboutTrueCore from "./pages/AboutTrueCore";
import Products from "./pages/Products";
import ProductTablet from "./pages/ProductTablet";
import ProductPC from "./pages/ProductPC";
import ProductDesktop from "./pages/ProductDesktop";
import ProductSmartGadgets from "./pages/ProductSmartGadgets";
import ContactTrueCore from "./pages/ContactTrueCore";
import TechnicalSpecs from "./pages/TechnicalSpecs";
import WarrantyPolicy from "./pages/WarrantyPolicy";
import Auth from "./pages/Auth";
import AdminContacts from "./pages/AdminContacts";
import ShippingPolicy from "./pages/ShippingPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Blog from "./pages/Blog";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <HelmetProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about-truecore-gadgets" element={<AboutTrueCore />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/tablets" element={<ProductTablet />} />
            <Route path="/products/pcs" element={<ProductPC />} />
            <Route path="/products/smart-gadgets" element={<ProductSmartGadgets />} />
            <Route path="/product/tablets" element={<Navigate to="/products/tablets" replace />} />
            <Route path="/product/pcs" element={<Navigate to="/products/pcs" replace />} />
            <Route path="/product/desktops" element={<ProductDesktop />} />
            <Route path="/contact-truecore" element={<ContactTrueCore />} />
            <Route path="/technical-specifications" element={<TechnicalSpecs />} />
            <Route path="/warranty-policy" element={<WarrantyPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin-contacts" element={<AdminContacts />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
